import { render, staticRenderFns } from "./showZheng.vue?vue&type=template&id=60a90f5f&"
import script from "./showZheng.vue?vue&type=script&lang=js&"
export * from "./showZheng.vue?vue&type=script&lang=js&"
import style0 from "./showZheng.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports